import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import CustomerService from "../Customer/Controller/CustomerController";
import Swal from 'sweetalert2';
import CustomerEmailing from "../Customer/View/CustomerForms/CustomerEmailingList";
import ContactEmailingList from "../Customer/View/CustomerForms/ContactEmailingList";
import LeadEmailingList from "../Lead/Views/LeadForms/LeadEmailingList";
import OpportunityEmailing from "../Oppurtunity/Views/OpportunityForms/OpportunityEmailing";
function CustomerEmailingList({ show, onClose, ModuleID, handleSelect, OnReset }) {
    const { theme } = useContext(ThemeContext);

    const [customerEmailName, setCustomerEmailName] = useState([]);
    const [selectedEmailName, setSelectedEmailName] = useState(""); // 🔹 new state for dropdown
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleStart = (e, ui) => e.stopPropagation();

    // ---------------------- FETCH FUNCTIONS ----------------------
    useEffect(() => {
        fetchEmailingName(); // populate dropdown
    }, []);

    async function fetchEmailingName() {
        try {
            const emailNameList = await CustomerService.GetEmailingByName(ModuleID);
            setCustomerEmailName(emailNameList);
        } catch (error) {
            console.error('Error fetching emailing names:', error);
        }
    }

    const truncateText = (text, maxLength = 30) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleEditClick = async (EmailingName) => {
        handleSelect(EmailingName);
    };
    const handleCloseModal = async () => {
        setIsModalOpen(false);
    };
    const handleDeleteClick = async (event, EmailingName) => {
        event.stopPropagation();
        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to delete`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: "Confirm"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    await CustomerService.DeleteEmailingByName(ModuleID, EmailingName);
                    fetchEmailingName();

                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });

    };
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1">
            <div className="modal-dialog modal-sm emailingList">
                <Draggable
                    handle=".modal-header"
                    onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Emailing Name</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            {/* 🔹 Dropdown Above Table */}

                            {/* Table */}
                            <div style={{ marginLeft: "10px", marginRight: "0px", marginTop: "10px" }}>
                                <table className="table table-striped" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>

                                            <th className="no-wrap">Name</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customerEmailName.map((customer, index) => (
                                            <tr key={customer.ID} style={{ cursor: 'pointer' }}
                                                onClick={() => handleEditClick(customer.EmailingName)}>

                                                <td className="no-wrap">{truncateText(customer.EmailingName)}</td>
                                                <td style={{ "textAlign": "right" }}>

                                                    <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={(event) => handleDeleteClick(event, customer.EmailingName)}>
                                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-warning" type="button" onClick={OnReset}>
                                Reset
                            </button>
                            <button className="btn btn-secondary" type="button" onClick={onClose}>
                                <i className="icofont-close" aria-hidden="true"></i> Close
                            </button>
                        </div>
                    </div>
                </Draggable>
            </div>
            {isModalOpen && ModuleID === "2" && (
                <CustomerEmailing
                    show={isModalOpen}
                    onClose={handleCloseModal}
                    EmailingName={selectedEmailName}

                />
            )}
            {isModalOpen && ModuleID === "15" && (
                <ContactEmailingList
                    show={isModalOpen}
                    onClose={handleCloseModal}
                    EmailingName={selectedEmailName}

                />
            )}
            {isModalOpen && ModuleID === "17" && (
                <LeadEmailingList
                    show={isModalOpen}
                    onClose={handleCloseModal}
                    EmailingName={selectedEmailName}

                />
            )}
            {isModalOpen && ModuleID === "18" && (
                <OpportunityEmailing
                    show={isModalOpen}
                    onClose={handleCloseModal}
                    EmailingName={selectedEmailName}

                />
            )}


        </div>
    );
}

export default CustomerEmailingList;
